import React, { useRef, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { register, resetRegister, clearInviteError, getInvitation } from 'actions/session';
import { errorSet, errorClear } from 'actions/error';

import Register from './Register';
import { getQueryString } from 'utils';

export const RegisterContainer = ({
  loading,
  history,
  errorSet,
  errorClear,
  inputErrors,
  errorMessage,
  invitationError,
  dispatchRegister,
  registerSubmitted,
  dispatchResetRegister,
  dispatchClearInviteError,
  ...props
}) => {
  const [step, setStep] = useState(0);
  const [values, setValues] = useState({});
  const [success, setSuccess] = useState(false);
  const inviteTokenRef = useRef(getQueryString(props).get('invite_token'));
  const [accountInvite, setAccountInvite] = useState(inviteTokenRef.current);
  const emailSetRef = useRef(false);

  const started = useRef(Date.now());
  const invitation = props.invitations.find(i => i.id === inviteTokenRef.current);

  useEffect(() => {
    if (invitation && invitation.email_address && !emailSetRef.current) {
      setValues(s => ({ ...s, email_address: invitation.email_address}));
      emailSetRef.current = true;
    }
  }, [ invitation ])

  useEffect(
    function clearState() {
      errorClear();
      dispatchClearInviteError();
      dispatchResetRegister();
    },
    [dispatchClearInviteError, dispatchResetRegister, errorClear]
  );

  useEffect (function onInvitationError () {
    if (invitationError) {
      setAccountInvite(false);
    }
  }, [ invitationError ])

  useEffect(function getInvitation () {
    if (inviteTokenRef.current) {
      props.dispatchGetInvitation(inviteTokenRef.current);
    }
  }, []);

  useEffect(() => {
    if (started.current < registerSubmitted) {
      setSuccess(true);
    }
  }, [registerSubmitted]);

  const toggleCreateAccount = () => {
    setAccountInvite(s => s ? false : inviteTokenRef.current);
  }

  const handleErrors = (inputErrors) => {
    errorClear();
    inputErrors && errorSet({ inputErrors });
  };

  const onNext = ({ isValid, errors, values }) => {
    handleErrors(errors);

    if (isValid) {
      setValues(values);
      setStep(step + 1);
    }
  };

  const onLogin = () => history.replace('/login');

  const onPrev = () => step > 0 && setStep(step - 1);

  const onCardAdd = (token) => {
    dispatchRegister({
      name: values.name,
      stripe_source_id: token.id,
      last_name: values.last_name,
      first_name: values.first_name,
      email_address: values.email_address,
      mobile_number: values.mobile_number,
      address_line1: values.address_line1,
      address_line2: values.address_line2,
      address_state: values.address_state,
      address_suburb: values.address_suburb,
      address_postcode: values.address_postcode
    });
  };

  const onRegister = ({ isValid, errors, values }) => {
    handleErrors(errors);

    if (isValid) {
      setValues(values);
    } else {
      return;
    }

    dispatchRegister({
      name: values.name,
      last_name: values.last_name,
      first_name: values.first_name,
      email_address: values.email_address,
      mobile_number: values.mobile_number,
      address_line1: values.address_line1,
      address_line2: values.address_line2,
      address_state: values.address_state,
      address_suburb: values.address_suburb,
      address_postcode: values.address_postcode
    });
  };

  const onInviteRegister = () => {
    dispatchRegister({
      first_name: values.first_name,
      last_name: values.last_name,
      email_address: invitation.email_address,
      mobile_number: values.mobile_number,
      invite_token: inviteTokenRef.current
    });
  }

  return (
    <Register
      step={step}
      values={values}
      onNext={onNext}
      onPrev={onPrev}
      onLogin={onLogin}
      success={success}
      loading={loading}
      errorSet={errorSet}
      errors={inputErrors}
      onCardAdd={onCardAdd}
      onRegister={onRegister}
      errorClear={errorClear}
      errorMessage={errorMessage}
      accountInvite={!!accountInvite}
      invitationError={invitationError}
      onCreateAccount={toggleCreateAccount}
      onInviteRegister={onInviteRegister}
      invitation={invitation}
    />
  );
};

let mapDispatchToProps = {
  errorSet,
  errorClear,
  dispatchRegister: register,
  dispatchGetInvitation: getInvitation,
  dispatchResetRegister: resetRegister,
  dispatchClearInviteError: clearInviteError
};

let mapStateToProps = ({ error, session, orders, loading }) => ({
  invitationError: session.invitationError,
  invitations: session.invitations,
  loading: loading.loadingSession,
  errorMessage: error.message || '',
  inputErrors: error.inputErrors || {},
  registerSubmitted: session.registerSubmitted
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(RegisterContainer)
);
